import { useI18n } from 'vue-i18n';

// словари единиц времени
const timeUnits = {
  en: {
    sec: ['second', 'seconds', 'seconds'],
    min: ['minute', 'minutes', 'minutes'],
    hr: ['hour', 'hours', 'hours'],
    day: ['day', 'days', 'days'],
  },
  ru: {
    sec: ['секунда', 'секунды', 'секунд'],
    min: ['минута', 'минуты', 'минут'],
    hr: ['час', 'часа', 'часов'],
    day: ['день', 'дня', 'дней'],
  },
  pl: {
    sec: ['sekunda', 'sekundy', 'sekund'],
    min: ['minuta', 'minuty', 'minut'],
    hr: ['godzina', 'godziny', 'godzin'],
    day: ['dzień', 'dni', 'dni'],
  },
  es: {
    sec: ['segundo', 'segundos', 'segundos'],
    min: ['minuto', 'minutos', 'minutos'],
    hr: ['hora', 'horas', 'horas'],
    day: ['día', 'días', 'días'],
  },
  kk: {
    sec: ['секунд', 'секунд', 'секунд'],
    min: ['минут', 'минут', 'минут'],
    hr: ['сағат', 'сағат', 'сағат'],
    day: ['күн', 'күн', 'күн'],
  },
  bg: {
    sec: ['секунда', 'секунди', 'секунди'],
    min: ['минута', 'минути', 'минути'],
    hr: ['час', 'часа', 'часа'],
    day: ['ден', 'дни', 'дни'],
  },
};

// вспомогательная функция для правильных окончаний
function pluralize(num, [one, few, many], locale) {
  if (['en', 'es', 'kk', 'bg'].includes(locale)) {
    return num === 1 ? one : many;
  }
  if (['ru', 'pl'].includes(locale)) {
    if (num % 10 === 1 && num % 100 !== 11) return one;
    if (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20))
      return few;
    return many;
  }
  return many;
}

// основная функция форматирования
function formatTimeLocalized(timeInSeconds, locale = 'en') {
  const t = timeUnits[locale] || timeUnits.en;

  if (timeInSeconds >= 86400) {
    const days = Math.floor(timeInSeconds / 86400);
    const hours = Math.floor((timeInSeconds % 86400) / 3600);
    const dayLabel = pluralize(days, t.day, locale);
    const hourLabel = pluralize(hours, t.hr, locale);
    return `${days} ${dayLabel}${hours > 0 ? ` ${hours} ${hourLabel}` : ''}`;
  }

  if (timeInSeconds >= 3600) {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const hourLabel = pluralize(hours, t.hr, locale);
    const minLabel = pluralize(minutes, t.min, locale);
    return `${hours} ${hourLabel}${minutes > 0 ? ` ${minutes} ${minLabel}` : ''}`;
  }

  if (timeInSeconds >= 60) {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    const minLabel = pluralize(minutes, t.min, locale);
    const secLabel = pluralize(seconds, t.sec, locale);
    return `${minutes} ${minLabel}${seconds > 0 ? ` ${seconds} ${secLabel}` : ''}`;
  }

  const secLabel = pluralize(timeInSeconds, t.sec, locale);
  return `${Math.floor(timeInSeconds)} ${secLabel}`;
}

export function useTimeFormatter() {
  const { locale } = useI18n();

  const formatTime = seconds => formatTimeLocalized(seconds, locale.value);

  return { formatTime };
}
